import { render, staticRenderFns } from "./HeaderFigma.vue?vue&type=template&id=b0a45642&scoped=true&"
import script from "./HeaderFigma.vue?vue&type=script&lang=js&"
export * from "./HeaderFigma.vue?vue&type=script&lang=js&"
import style0 from "./HeaderFigma.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HeaderFigma.vue?vue&type=style&index=1&id=b0a45642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a45642",
  null
  
)

export default component.exports